import { keepPreviousData, useQuery } from "@tanstack/react-query";
import useApi from "../../../shared/hooks/useApi";
import { queryKeys } from "../../../shared/query-keys";

/**
 * Caregiver search for the dialer.
 *
 * Deliberately not the caregiver search index: the dialer needs a number to
 * dial, and `phoneNumbersExtended` - which carries the type and SMS-ability of
 * each number - is not in the index. This goes to the global search endpoint,
 * which hydrates full caregiver rows from Postgres.
 */
export function useDialerCaregiversSearchQuery(params: { term: string }) {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKeys.caregiver.search(`dialer:${params.term}`),
    queryFn: () =>
      api.get("/agencies/:agencyId/search", {
        query: {
          caregiver_id: true,
          caregiver_first_name: true,
          caregiver_last_name: true,
          text: params.term,
        },
      }),
    enabled: params.term !== "",
    select: (data) => data.caregivers.slice(0, 10),
    placeholderData: params.term !== "" ? keepPreviousData : undefined,
  });
}
